// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"6952ba4d","703":"1dcc9842"}[chunkId] + ".chunk.js";
};